import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EmailHeaderAndFooterTemplate } from "../models/NotificationsModels/EmailHeaderAndFooterTemplate";
import { RequestHandlerService,AuthService, RequestOptionsModel } from "bbsf-utilities";

@Injectable({
    providedIn: 'root'
})
export class EmailHeaderAndFooterTemplateService {
    ApiUrl = "/api/admin/EmailHeaderAndFooterTemplate/"
    constructor(private http: RequestHandlerService) {
    }


    AddEmailHeaderAndFooterTemplate( AddModel: EmailHeaderAndFooterTemplate) {
       
        return this.http.post( this.ApiUrl + 'AddEmailHeaderAndFooterTemplate', AddModel);
    }
    GetEmailHeaderAndFooterTemplateById(id: number) {
     
        let params = new HttpParams();
        params = params.append("id", id.toString());
        return this.http.get( this.ApiUrl + 'GetEmailHeaderAndFooterTemplateById', params)

    }

    EditEmailHeaderAndFooterTemplate( EditModel) {
      
        return this.http.post( this.ApiUrl +'editEmailHeaderAndFooterTemplate', EditModel);
    }
    GenerateCode() {
    
        return this.http.get( this.ApiUrl + 'GenerateCodeAll',null);
    }
    DeleteHeaderAndFooterTemplate( id: number) {
       
        return this.http.post( this.ApiUrl + 'DeleteEmailHeaderAndFooterTemplate', id);
    }


}